import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  fireAdobeAnalyticsEvent,
  analyticsCtaDataObject,
  handleFileDownloadEvent,
  analyticsLabelFromString,
} from '../../../helpers/adobe-analytics';

export class Luanne extends Lit3formBlock {
  static get characterName() {
    return 'luanne';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid luanne-layout">
          <h2>${unsafeHTML(this.headerStr)}</h2>
          <p class="description">${unsafeHTML(this.descriptionStr)}</p>
          <cta-text
            cta-data=${this.ctaData}
            .ctaAnalyticsData=${analyticsCtaDataObject(
              this.ctaData,
              this.headerStr
            )}
          ></cta-text>
          <div
            class="${classMap({
              'six-per-row': this.imagesPerRow === 'six',
              'eight-per-row': this.imagesPerRow === 'eight',
              images: true,
            })}"
          >
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    return !!image.url
      ? html`
          <a
            class="image-wrapper"
            href=${this.imageHref(image)}
            @click="${() => this.imageClicked(image)}"
          >
            ${this.imageInternalHtml(image)}
          </a>
        `
      : html`
          <a
            class="image-wrapper download-cursor"
            href=${this.imageHref(image)}
            target="_blank"
            rel="noopener"
            @click="${() => this.imageClicked(image)}"
          >
            ${this.imageInternalHtml(image)}
          </a>
        `;
  }

  imageInternalHtml(image) {
    return !!image.text
      ? html`
          <div class="image">
            <img
              src=${this.imageUrl(image)}
              class="${classMap({
                'add-border': image.apply_border === '1',
              })}"
            />
            <p class="font-size-small">
              ${unsafeHTML(this.withLineBreaks(image.text))}
            </p>
          </div>
        `
      : html`
          <div class="image">
            <img src=${this.imageUrl(image)} />
          </div>
        `;
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    // Sample image ratios are generally 25/32
    // this adjusts the color chip images to cover that ratio from ImageBoss
    const height = image.url?.includes('color-chip') ? (250 / 25) * 32 : null;
    return this.imagebossUrl(image.src, 250, height);
  }

  imageClicked(image) {
    // Adobe Analytics handling
    if (!!image.url) {
      // use navigation event
      const eventData = {
        type: 'click',
        detail: {
          eVar8: `NAV|${this.headerStr}|${image.text}`,
        },
      };
      fireAdobeAnalyticsEvent(eventData);
    } else {
      // use download event
      const downloadData = {
        file_format: 'JPG',
        file_name: analyticsLabelFromString(image.text),
        link_url: image.full_resolution_src,
        link_type: 'IMAGE',
        placement: analyticsLabelFromString(this.headerStr),
      };
      handleFileDownloadEvent(analyticsCtaDataObject(downloadData));
    }
  }

  get imagesPerRow() {
    return this.content.images_per_row || 'six';
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionStr() {
    return this.withLineBreaks(this.content.description) || '';
  }

  get ctaData() {
    return JSON.stringify(this.content.cta);
  }

  get imagesArr() {
    if (!this.content.images || this.content.images.length === 0) {
      return [];
    }
    return this.content.images;
  }
}
Luanne.defineElement();
